export const leucocytesUnit = '\u00D7 10\u2079 / л';
export default function (val: string | number) {
  if (!val) {
    return '';
  }

  return `${val ?? ''} ${leucocytesUnit}`;
}
